<opac-table>
  <opac-table-row>
    <opac-table-cell-header>{{ 'physical.fascicles' | translate }}</opac-table-cell-header>
  </opac-table-row>

  <opac-table-row *ngFor="let fascicleList of fascicleRecordsDisplayList">
    <opac-table-cell-text>{{ fascicleList[0] }}</opac-table-cell-text>
    <opac-table-cell>
      <opac-button *ngFor="let fascicle of fascicleList[1]" [type]="'text'" (click)="handleButtonClick(fascicle)">
        {{ fascicle.number }}
      </opac-button>
    </opac-table-cell>
  </opac-table-row>
</opac-table>

<div *ngIf="fasciclesByYear.length > pageSize" class="show-all-records">
  <opac-button type="text" (click)="isAllItemsDialogOpened = true">
    {{ 'info.physicalRecord.viewAllFascicles' | translate }}
  </opac-button>
</div>

<div class="paginator" *ngIf="fasciclesByYear.length > pageSize">
  <mat-paginator
    [length]="fasciclesByYear.length"
    [pageSize]="pageSize"
    (page)="fasciclePage($event)"
    [hidePageSize]="true"
    [showFirstLastButtons]="true">
  </mat-paginator>
</div>

<opac-dialog [title]="'physical.fascicles' | translate" [size]="'full'" [open]="isAllItemsDialogOpened" (closed)="isAllItemsDialogOpened = false">
  <opac-table>
    <opac-table-row *ngFor="let fascicleList of fasciclesByYear">
      <opac-table-cell-text>{{ fascicleList[0] }}</opac-table-cell-text>
      <opac-table-cell>
        <opac-button *ngFor="let fascicle of fascicleList[1]" [type]="'text'" (click)="handleButtonClick(fascicle)">
          {{ fascicle.number }}
        </opac-button>
      </opac-table-cell>
    </opac-table-row>
  </opac-table>
</opac-dialog>
